module.exports = __webpack_public_path__ + "static/media/astro_comms_media_transportation_hospitality.9b4d24f1.png";